import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Desguace en L\'Hospitalet de Llobregat – Compra de Coches',
  description: 'Compramos coches en L\'Hospitalet de Llobregat al mejor precio. Siniestrados, averiados, sin ITV. Recogida gratuita y pago inmediato.',
  provider: {
    '@type': 'AutoDealer',
    name: 'Desguace Barcelona',
    telephone: '+34932932913',
    address: { '@type': 'PostalAddress', addressLocality: 'L\'Hospitalet de Llobregat', addressRegion: 'Cataluña', addressCountry: 'ES' },
  },
  areaServed: { '@type': 'City', name: 'L\'Hospitalet de Llobregat' },
  url: `${siteUrl}/desguace-hospitalet`,
};

export default function DesguaceHospitaletPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Desguace en L'Hospitalet de Llobregat | Mejor Precio | Recogida Gratis"
        description="Desguace en L'Hospitalet de Llobregat. Compramos coches siniestrados, averiados o sin ITV al mejor precio. Recogida gratuita en toda la ciudad y pago inmediato."
        keywords="desguace Hospitalet, vender coche Hospitalet, compra coches Hospitalet Llobregat, desguace L'Hospitalet"
        canonical={`${siteUrl}/desguace-hospitalet`}
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1a2332] to-[#2d3e50]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
              Desguace en L'Hospitalet
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Compramos tu coche en L'Hospitalet de Llobregat. Servicio de recogida gratuita y pago al instante.
            </p>
          </div>
        </section>

        {/* Contenido Principal */}
        <article className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            
            <div className="prose prose-lg max-w-none mb-12">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                <strong>Desguace L'Hospitalet</strong> es tu solución para vender tu coche en la segunda ciudad más poblada de Cataluña. Ofrecemos el mejor precio por tu vehículo, ya sea que esté siniestrado, averiado, sin ITV o simplemente quieras deshacerte de él.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Con más de <strong>15 años de experiencia</strong> en L'Hospitalet de Llobregat, conocemos cada barrio y ofrecemos un servicio rápido y profesional. Recogemos tu coche en cualquier punto de la ciudad sin coste adicional.
              </p>
            </div>

            {/* Barrios de L'Hospitalet */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Barrios de L'Hospitalet Donde Operamos
              </h2>
              
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
                {['Centre', 'Santa Eulàlia', 'Collblanc', 'La Torrassa', 'La Florida', 'Les Planes', 'Pubilla Cases', 'Can Serra', 'Gornal', 'Bellvitge', 'Gran Via Sud', 'Sant Josep'].map((barrio) => (
                  <div key={barrio} className="bg-[#f8f9fa] p-4 rounded-lg text-center">
                    <i className="ri-map-pin-line text-[#ff6b35] text-xl mb-2"></i>
                    <p className="text-sm font-medium text-[#1a2332]">{barrio}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Ventajas */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Ventajas de Nuestro Servicio en L'Hospitalet
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-truck-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Recogida Gratuita</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Vamos a buscar tu coche a cualquier punto de L'Hospitalet sin coste alguno.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-time-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Servicio Rápido</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Tasación en 24 horas y recogida en 48-72 horas máximo.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-money-euro-circle-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Mejor Precio</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Ofrecemos las mejores tasaciones de L'Hospitalet. Garantizado.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-file-list-3-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Gestión Completa</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Nos encargamos de toda la documentación y trámites legales.
                  </p>
                </div>
              </div>
            </section>

            {/* Tipos de coches */}
            <section className="mb-16 bg-[#f8f9fa] p-8 rounded-2xl">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Tipos de Vehículos que Compramos
              </h2>
              
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Siniestrados:</strong> Coches con daños por accidente o siniestro total.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Averiados:</strong> Cualquier tipo de avería mecánica o eléctrica.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Sin ITV:</strong> Vehículos con inspección caducada o que no la pasan.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Antiguos:</strong> Coches viejos o que llevan tiempo sin usar.</p>
                </div>
              </div>
            </section>

            {/* CTA Final */}
            <section className="bg-gradient-to-br from-[#1a2332] to-[#2d3e50] rounded-2xl p-12 text-center text-white">
              <h2 className="text-4xl font-black mb-4">
                Vende tu Coche en L'Hospitalet
              </h2>
              <p className="text-xl mb-8 text-white/90">
                Contacta ahora y recibe tu tasación gratuita
              </p>
              <a 
                href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20valorar%20mi%20coche%20en%20L%27Hospitalet" 
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center px-10 py-5 bg-[#25d366] text-white rounded-full font-bold text-lg hover:bg-[#1da851] transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-3 text-2xl"></i>
                WhatsApp 932 932 913
              </a>
            </section>

          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
